"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function Button(_a) {
    var action = _a.action, active = _a.active, icon = _a.icon, onClick = _a.onClick, text = _a.text;
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    react_1.default.createElement("div", { className: "button " + action, onClick: active ? onClick : undefined, style: active ? { opacity: "1" } : { opacity: "0.5" } }, icon ? react_1.default.createElement("i", { className: icon, "aria-hidden": "true" }) : text));
}
exports.default = Button;
